import { useRef,useState,useEffect} from 'react';
// @mui
import { Pagination, Stack ,Grid} from '@mui/material';
// types
import { useNavigate } from "react-router-dom";

import { ICourseProps } from 'src/types/course';
//
import { ElearningTeacherItem, ElearningTeacherItemSkeleton,ElearningTeacherItemCard } from '../item';

// ----------------------------------------------------------------------

type Props = {
  teachers: any[];
  loading?: boolean;
  type : string;
  // total : number;
  // page : any;
};

export default function ElearningTeacherList({ teachers, loading ,type}: Props) {
    /* eslint-disable */

  return (
    <>
      {/* <Stack spacing={5}>
        {(loading ? [...Array(9)] : courses).map((course, index) =>
          course ? type === "1" ? (
            <ElearningCourseItem key={course.id} course={course} />
          ) 
          :
          (
            <ElearningCourseItemCard vertical key={course.id} course={course} />
            // <ElearningCourseItem vertical key={course.id} course={course} />
                      ) 

          : (
            <ElearningCourseItemSkeleton key={index} />
          )
        )}
      </Stack> */}
      {type === "1" ? 
      <Stack spacing={5}>
        {(loading ? [...Array(9)] : teachers).map((teacher, index) =>
          teacher ?       
          (
            <ElearningTeacherItem key={teacher.teacherIdx} teacher={teacher} />
            // <ElearningCourseItem vertical key={course.id} course={course} />
                      ) 

          : (
            <ElearningTeacherItemSkeleton key={index} />
          )
        )}
      </Stack>
      
      :
      
      <Grid container spacing={3}>
        {(loading ? [...Array(9)] : teachers).map((teacher, index) =>
          teacher ?       
          (
            <Grid item xs={6} sm={4} md={3}>
              <ElearningTeacherItemCard vertical key={teacher.teacherIdx} teacher={teacher} />

            </Grid>
            // <ElearningCourseItem vertical key={course.id} course={course} />
                      ) 

          : (
            <ElearningTeacherItemSkeleton key={index} />
          )
        )}
      </Grid>
      }

      {/* <Pagination
        count={total}
        color="primary"
        size="large"
        onChange={handleChange}
        sx={{
          my: 10,
          '& .MuiPagination-ul': {
            justifyContent: 'center',
          },
        }}
      /> */}
    </>
  );
}
